import React, { Component } from 'react';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import Logo from '../../assets/images/kinship-logo.svg';
import Facebook from '../../assets/images/facebook.png';
import Google from '../../assets/images/google.png';

export default class SignupPage extends Component {
    constructor() {
        super()
    }

    render() {
        return (
            <div className='login'>
                <div className="container">
                    <div className="loginMainDiv">
                        <div className="LogoDiv">
                            <img src={Logo} alt="logo" />

                        </div>
                        <div className='welcome-div'>
                            <h4 className='welcome'>Join Kinship Living today</h4>
                           
                        </div>

                        <form style={{ paddingTop: '10px', textAlign: 'center' }}>
                            <div className="row" >
                            <div className="col-md-12 col-lg-12">  
                            <div class="form-group"  >

                                    <input type="text" class="form-control-ausi" id="txtSignupFirstName" name="txtSignupFirstName" value={this.props.txtSignupFirstName} onChange={this.props.HandleSignupInputs} 
                                    onKeyDown={(e)=>this.props.CheckSignUp(e)}
                                    placeholder="Enter First Name " />

                                </div>
                                </div> 
                                <div className="col-md-12 col-lg-12">
                                <div class="form-group"  >

                                    <input type="text" class="form-control-ausi" id="txtSignupLastName" name="txtSignupLastName" value={this.props.txtSignupLastName} onChange={this.props.HandleSignupInputs}
                                    onKeyDown={(e)=>this.props.CheckSignUp(e)}
                                    placeholder="Enter Last Name" />

                                </div>
                                </div>
                                <div className="col-md-12 col-lg-12">
                                <div class="form-group"  >

                                    <input type="text" class="form-control-ausi" id="txtSignupAge" name="txtSignupAge"
                                     value={this.props.txtSignupAge}
                                      onClick={this.props.HandleSignupInputs}
                                      onKeyDown={(e)=>this.props.CheckSignUp(e)}
                                    placeholder="Minimum Age 55 years" />
                                  {/* <div style={{textAlign:'left'}}>
                                    <small>Age must be 55+</small>
        </div> */ }

                                </div>
                                </div>
                                <div className="col-md-12 col-lg-12">
                                <div className="row">
                                <div className="col-3 col-md-3 col-lg-3" style={{paddingLeft:'23px'}}>
                                <div class="form-group"  >

                                    <input type="text" class="form-control-ausi" id="txtSignupUserMobileCode"
                                     name="txtSignupUserMobileCode"
                                    
                                     value={this.props.txtSignupUserMobileCode} />

                                </div>
                                
                                </div>
                                <div className="col-9 col-md-9 col-lg-9" style={{paddingLeft:'0px'}}>
                                <div class="form-group"  >

                                    <input type="text" class="form-control-ausi" id="txtSignupUserMobile" name="txtSignupUserMobile" value={this.props.txtSignupUserMobile} onChange={this.props.HandleSignupInputs}
                                    onKeyDown={(e)=>this.props.CheckSignUp(e)}
                                    placeholder="Enter Mobile Number" />

                                </div>
                                </div>
                                </div>
                                
                                </div>
                                <div className="col-md-12 col-lg-12">
                                <div class="form-group"  >

                                    <input type="email" class="form-control-ausi" id="txtSignupEmail" name="txtSignupEmail" value={this.props.txtSignupEmail} onChange={this.props.HandleSignupInputs} 
                                    onKeyDown={(e)=>this.props.CheckSignUp(e)}
                                    placeholder="Enter email" />

                                </div>
                                </div>
                                <div className="col-md-12 col-lg-12">
                                <div class="form-group" >
                                    <input type="password" class="form-control-ausi" id="txtSignupPassword" name="txtSignupPassword" value={this.props.txtSignupPassword} onChange={this.props.HandleSignupInputs}
                                    onKeyDown={(e)=>this.props.CheckSignUp(e)}
                                    placeholder="Password" />

                                </div>
                                </div>
                                {this.props.txtSignupValidationMessage !== '' ?
                                    <div className="col-md-12 col-lg-12">
                                        <div className="ausaf-errorMessage">{this.props.txtSignupValidationMessage}</div>
                                    </div> : null}
                                    <div className="col-md-12 col-lg-12">
                                <button type="button" class="btn login-button" id="btnSignupButton" name="btnSignupButton" onClick={this.props.Signup}>Sign-up</button>
                               </div>
                               <div className="col-md-12 col-lg-12">
                                <div className="signup-terms-info">
                                    <p>By clicking Sign-up, you agree to the <span onClick={() => this.props.HandleRouting('terms-conditions')}>Terms & Conditions</span> and <span onClick={() => this.props.HandleRouting('privacy-policy')}>Privacy Policy</span></p>
                                </div>
                                </div>
                                <div className="col-md-12 col-lg-12">
                                <div className='signup-link-div'>
                                    <div><p>Already have an account?</p></div>
                                    <div className="sign-up-link cursor-pointer" onClick={() => this.props.HandleRouting('login')}><p>Login</p></div>
                                </div>
                                </div>
                            </div>
                        </form>
                        <div className='login-page-partition'>
                            <div className='login-partition-line'></div>
                            <span>OR</span>
                            <div className='login-partition-line'></div>
                        </div>

                        <div className='social-login'>
                            <div className="google-login-btn" style={{ display: 'flex' }}>
                                <img className="social-login-btn-logo" src={Google} alt="google" />
                                <GoogleLogin
                                    clientId="833238440283-s64g3p22cvd7vfb00jmpv47i2kap8bvf.apps.googleusercontent.com"
                                    buttonText="Continue with Google"
                                    id="btnGoogleSignupButton"
                                    name="btnGoogleSignupButton"
                                    onSuccess={this.props.responseSuccessGoogle}
                                    onFailure={this.props.responseFailureGoogle}
                                    cookiePolicy={'single_host_origin'}
                                />
                            </div>

                            <div className='facebook-login-btn'>
                                <img className="social-login-btn-logo" src={Facebook} alt="facebook" />
                                <FacebookLogin
                                    appId="873255453283482"
                                    autoLoad={false}
                                    textButton="Continue with Facebook"
                                    id="btnFacebookSignupButton"
                                    name="btnFacebookSignupButton"
                                    fields="name,email,picture"
                                    //onClick={componentClicked}
                                    callback={this.props.responseSuccessFacebook}
                                />
                            </div>

                        </div>
                    </div>

                </div>


            </div>
        )
    }
}